const messages = {
  title: "Butik",
  description: "Velkommen til belønningsbutikken. Her kan du indløse dine Bridgestone Plus-point <br/> til belønninger fra forskellige kategorier. Udvalget af produkter <br/> opdateres løbende. Vi håber, du nyder at browse.",
  sort: {
    asc: "Sorter efter: Laveste pris",
    desc: "Sorter efter: Højeste pris",
  },
  productSearchBox: {
    from: "point fra",
    to: "point til",
  },
  noProducts: "Søgekriterierne gav ingen resultater",
  quantity: "Antal",
  search: "Søg",
  perPage: "Elementer pr. side",
  timeUnavailable: "I øjeblikket ikke tilgængelig",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Point pr. enhed",
    pointsSum: "Sum af point",
  },
  action: "Handling",
  pointsTotal: "I alt",
  cartRemainPoints: "Resterende point i kurv",
  shoppingCart: "Indkøbskurv",
  emptyCart: "Indkøbskurven er tom.",
  attributes: "Attributter",
  selectAddressP: "Vælg venligst din leveringsadresse",
  orderDelivery: "Leveringsadresse",
  selectedProducts: "Valgte produkter",
  orderSummary: "Ordreoversigt",
  contactPerson: "Kontaktperson",
  selectedAddress: "Valgt adresse",
  order: {
    success: "Tak! Din ordre blev gennemført. Du modtager en ordrebekræftelse i din indbakke om få minutter.",
    description: "Her finder du en oversigt over dine ordrer fra belønningsshoppen.",
    info: "Her finder du en oversigt over dine ordrer fra belønningsshoppen.",
    date: "Ordredato",
    number: "Ordrenr.",
    status: {
      created: "Oprettet",
      confirm_order: "Bekræft ordre",
      ready_for_shipment: "Klar til forsendelse",
      rejected: "Afvist",
      processed: "Behandlet",
      shipped: "Afsendt",
      returned: "Returneret",
      finished: "Afsluttet",
    },
    anyOrder: "Ingen ordrer",
    products: "Produkter",
    quantity_short: "stk",
    itemRemoved: "kan ikke leveres",
  },
  orders: "Ordrer",
  notEnoughPoints: "Der er ikke nok point til rådighed.",
  statusText: "Status",
  outOfStock: "I øjeblikket ikke på lager",
  productUnavailable: "Dette produkt er ikke længere tilgængeligt.",
  deletedProductsTitle: "Produkter ikke længere tilgængelige",
  deletedProductsMessage: "Følgende produkter er ikke længere tilgængelige. Fjern dem fra kurven for at fortsætte.",
  removeSelected: "Fjern valgte",
  clearCart: "Tøm indkøbskurv",
  removeSelectedConfirm: "Fjerne de valgte produkter fra indkøbskurven?",
  clearCartConfirm: "Fjerne alle produkter fra indkøbskurven?",
  incompleteAddress: {
    firstName: "Tilføj venligst et fornavn til leveringsadressen",
    lastName: "Tilføj venligst et efternavn til leveringsadressen",
    company: "Tilføj venligst et firmanavn til leveringsadressen",
    street: "Tilføj venligst en gade og husnummer til leveringsadressen",
    postalCode: "Tilføj venligst et postnummer til leveringsadressen",
    city: "Tilføj venligst en by til leveringsadressen",
    country: "Tilføj venligst et land til leveringsadressen",
    phone: "Tilføj venligst et telefonnummer til leveringsadressen",
  },
  placeOrder: "Bindende ordre",
  toOrderDelivery: "Fortsæt til leveringsadresse",
  toOrderSummary: "Til ordreoversigt",
  productImg: "Produktbillede",
  selectAddressBtn: "Vælg adresse",
  perPgae: "Elementer pr. side",
  categories: {
    advertising: {
      title: "Reklamemateriale",
      desc: "Deltag direkte her på platformen og sikre <br/> 40 ekstra point til belønningsklubben.",
    },
    rewards: {
      title: "Eksklusive belønninger",
      desc: "Opdag bonustilbuddet i vores træningscenter eller hos dig.",
    },
    tools: {
      title: "Værkstedsværktøj",
      desc: "Brug dine point til tredjepartsuddannelse <br/> og reducer omkostningerne.",
    },
    trainings: {
      title: "Træning og kurser",
      desc: "Opdag bonustilbuddet i vores træningscenter eller hos dig.",
    },
    salesroom: {
      title: "Salgsrum",
      desc: "Indret salgsrummet og giv kunderne et behageligt ophold.",
    },
    hunter: {
      title: "Hunter",
      desc: "Byt point mod attraktivt værkstedsudstyr fra Hunter.",
    },
  },
  bestSold: "Bedst sælgende",
  seasonal: "Sæson",
  affordable: "Næsten i mål",
  forPoints: "for {points} point",
  reachedPoints: "Nødvendige point nået",
  remainingPoints: "{points} point tilbage",
  favoriteProducts: {
    description: "Her finder du de produkter, du har gemt.",
  },
  categoryPageDescriptionFallback: "Materiale til værkstedet eller andre kvalitetsprodukter med Bridgestone-logo til din virksomhed",
  variant: "Valgbare varianter",
};
export default {
  messages,
};
